import { DEFAULT_LOCALE } from 'common/constants/i18n';
import { useTranslation } from 'translation/intl-provider';

const $t = (str, values) => {
  const { locale, intls } = useTranslation();
  const englishIntl = intls[DEFAULT_LOCALE];
  const intl = intls[locale] ?? englishIntl;
  
  if(str) {
    return intl.formatMessage(
      {
        id: str,
        defaultMessage: str,
      },
      values,
      str,
    );
  }
  return '';
};

export default $t;
